import { PageContentLoader } from '@components';
import { useAppSelector } from '@hooks';
import { getSpecialPage, SystemPages } from '@store/app/app.slice';

export type SystemPageProps = {
  pageType: keyof SystemPages;
};

export const SystemPage = ({ pageType }: SystemPageProps) => {
  const page = useAppSelector(getSpecialPage(pageType));
  return page ? <PageContentLoader contentUrl={page} /> : <></>;
};

export const NotFoundPage = () => <SystemPage pageType='notFoundPage' />;
export const ServerErrorPage = () => <SystemPage pageType='errorPage' />;
export const ForbiddenPage = () => <SystemPage pageType='forbiddenPage' />;
export const LoginPage = () => <SystemPage pageType='loginPage' />;
export const ForgottenPasswordPage = () => <SystemPage pageType='forgotPasswordPage' />;
export const ResetPasswordPage = () => <SystemPage pageType='resetPasswordPage' />;
